import { render, staticRenderFns } from "./EditVinculationList.vue?vue&type=template&id=066230f4&scoped=true"
import script from "./EditVinculationList.vue?vue&type=script&lang=js"
export * from "./EditVinculationList.vue?vue&type=script&lang=js"
import style0 from "./EditVinculationList.vue?vue&type=style&index=0&id=066230f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066230f4",
  null
  
)

export default component.exports